import RestAPI from "../../../util/RestAPI";
import { Team } from "../Types/TeamTypes";

export async function listLobbyTeams(lobbyId: string) {
  try {
    const resp = await RestAPI.get("/lobbies/" + lobbyId + "/teams");
    const teams = (await resp.json()) as any as Team[];

    return teams;
  } catch (err: any) {
    throw new Error(err.message);
  }
}
